import moment from 'moment';
import { mapGetters } from 'vuex';

export const initLocale = {
  methods: {
    async initLocale() {
      const user = this.$store.getters['users/me'];
      const locale = user.communicationLanguage;
      this.$store.dispatch('language/setSelectedLanguage', locale);
      moment.locale(locale);
    }
  }
};

export const languageList = {
  data() {
    return {
      languages: {
        en: 'English',
        de: 'Deutsch',
        es: 'Español',
        fr: 'Français',
        it: 'Italiano',
        hu: 'Magyar',
        nl: 'Nederlands',
        pt: 'Português',
        fi: 'Suomi',
        sv: 'Svenska',
      },
      languageOptions: [],
    };
  },
  methods: {
    populateLanguagesSelectList() {
      Object.entries(this.languages).forEach(([code, lang]) => {
        this.languageOptions.push({
          name: lang,
          value: code,
        });
      });
    },
  },
  computed: {
    languageList() {
      return Object.entries(this.languages).map(([code, lang]) => {
        return {
          name: lang,
          value: code,
        };
      });
    }
  }
};

export const languageMethods = {
  methods: {
    getDefaultLanguage() {
      return 'en';
    },
    languageIsAvailable(language) {
      if (this.languages.map((l) => l.id).includes(language.toLowerCase())) return true;
      return false;
    },
    async selectLanguage(language) {
      return this.$store.dispatch('language/setSelectedLanguage', (this.languageIsAvailable(language) ? language.toLowerCase() : this.getDefaultLanguage()));
    },
  },
};

export const languageComputed = {
  computed: {
    ...mapGetters({
      storedLanguage: 'language/selectedLanguage',
    }),
    selectedLanguage() {
      if (this.languageIsAvailable(this.storedLanguage)) return this.storedLanguage;
      return this.getDefaultLanguage();
    },
    languages() {
      return this.$i18n.availableLocales
        .filter((name) => (name !== 'universal'))
        .map((language) => ({ id: language, name: this.$i18n.t(`languages.${language}`) }));
    },
  },
};
